export const BULLETINS_ROUTES = {
  __ROOT__: '/bulletins/',
  BULLETIN: '/bulletins/:bulletinId',
  BULLETIN_FORM: '/bulletins/form/:bulletinId?',
  BULLETIN_LIST: '/bulletins/:bulletinId?',
}
